import React, { useState } from "react"
import PropTypes from "prop-types"

import { Button } from "../styled"
import { QuestionsAndContactComponent } from "../index"
import { CrossCompanyPhoneCheck } from "../auth/CrossCompanyPhoneCheck"

const CAMEOSPARK_PROMO_CODE = "2022APPLETVP3"
const JAZZINFERNO_PROMO_CODE = "2022APPLETVP4"

export const AppleFitnessGetStartedComponent = (props) => {
  const [submissionPromoCode, setSubmissionPromoCode] = useState("CAMEOSPARK_PROMO_CODE")

  const initialValues = {
    phoneNumber: ""
  }

  const getButton = (promoCode) => ({disabled, handleClick}) => {
    return (
      <>
        {
          promoCode === CAMEOSPARK_PROMO_CODE &&
          <>
          <div className="row text-left" dangerouslySetInnerHTML={{__html : props.secondSectionText}}>
          </div>
          </>
        }
        {
          promoCode === JAZZINFERNO_PROMO_CODE &&
          <>
          <div className="row text-center">
          <p> <strong>T-Mobile for Business and Sprint customers on a Sprint ONE, Business Unlimited Advanced, or equivalent plan can get 6 months of Apple TV+ On Us!</strong>&nbsp;After 6 months, pay $6.99/mo. Cancel anytime. Subscriber account registration and credit card required. Cannot be combined with previous T-Mobile Apple TV+ promotions.&nbsp;</p>
          <p style={{ paddingLeft: "25px" }}><em>&ndash;Unsure if your plan qualifies? Unlimited for All, Unlimited Freedom, Magenta for Business, Business Unlimited,
             and ONE Business are also eligible, including Military, First Responder, 55+, and Deaf or Hard of Hearing/Visually Impaired versions of these plans.</em></p>
          </div>
          </>
        }
        <Button style={{ marginBottom: "40px" }}
          type="button"
          className="btn"
          primary
          disabled={disabled}
          onClick={() => {
            setSubmissionPromoCode(promoCode);
            sessionStorage.setItem('promoCode', promoCode);
            handleClick();
          }}
        >
          Continue
        </Button>
      </>)
  }

  const submitButtons = [
    getButton(CAMEOSPARK_PROMO_CODE),
    getButton(JAZZINFERNO_PROMO_CODE),
  ];

  return (
    <section>
      <div className="container py-5 hero3">
        <div className="row text-center">
        <div className="col" dangerouslySetInnerHTML={{__html : props.firstSectionText}}></div>
        </div>
        <div className="row text-center">
          <div className="col" style={{marginBottom: "6px"}}>
            <p>If you are a T-Mobile for Business customer, please click "<a href={process.env.REACT_APP_TMO_TFB_ID_AUTH_URL} rel="noreferrer">Here</a>".</p>
            <p><b>Start by entering your phone number</b></p>
          </div>
        </div>
        <div className="mx-auto col">
          <div>
            <CrossCompanyPhoneCheck initialValues={initialValues}   buttons={submitButtons} promoCode={submissionPromoCode} phoneInputClass="col-md-4 mx-auto"/>
          </div>
        </div>
        <div className="text-center">
          <QuestionsAndContactComponent />
        </div>
      </div>
    </section>
  )
}

AppleFitnessGetStartedComponent.propTypes = {
  setErrorMessage: PropTypes.func.isRequired,
  offerId: PropTypes.number
}
